import { createGlobalStyle } from 'styled-components';
import { primaryFont, SecondaryBgColor } from '../Utils/utilsStyle';

/** Login / SSO shell styles — loaded only on auth routes via DeferredAppStyles. */
const AuthStyle = createGlobalStyle`
  body {
    background-color: ${SecondaryBgColor}
  }
  .App-header {
    background-color: #282c34;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: calc(10px + 2vmin);
    color: white;
    p {
      font-family: ${primaryFont};
    }
  }
`;

export default AuthStyle;
